import { Button, colors, TextField, Typography } from "@mui/material";
import ProductTile from "components/ProductTile/ProductTile";
import { Box } from "@mui/material/node_modules/@mui/system";
import { useMobileContext } from "context/mobile/mobileContext";
import { useIntl } from "react-intl";
import { useMemo } from "react";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { isUBD } from "features/Mobile/utils";

export interface SingleItemCartProps {
  cardItemId?: string;
  onClose?: () => void;
}



export function SingleItemCart({ cardItemId, onClose }: SingleItemCartProps) {
  const intl = useIntl();
  const { cart, addItem, removeItem, updateDiscardDate } = useMobileContext();
  const product = useMemo(() => cart.find(({ id }) => cardItemId === id), [cart, cardItemId]);

  if (!product) {
    return <></>;
  }

  return (
    <>
      <Box sx={{ marginTop: '180px' }} />
      <Box
        boxShadow={6}
        sx={{
          position: 'fixed',
          padding: '14px',
          zIndex: 99,
          background: 'white',
          bottom: 0,
          left: 0,
          right: 0,
          borderTop: `1px solid ${colors.grey[200]}`,
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Box sx={{
          maxHeight: 'calc(100vh - 50px)',
          overflowY: 'auto',
        }}>
          <Typography variant="h6" component='h2'>
            {intl.formatMessage({ id: 'mobile.button.edit.title' })}
          </Typography>
          <Box>
            <ProductTile
              {...product}
              onAdd={addItem}
              onRemove={removeItem}
            />
          </Box>
        </Box>

        {isUBD(product.calculationDiscard) && (
          <Box sx={{ display: 'flex', paddingBottom: '16px', paddingTop: '16px', borderTop: `1px solid ${colors.grey[200]}` }}>
            <Typography sx={{ width: '40%', alignSelf: 'center' }}>Discard Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                renderInput={(props) => <TextField {...props} sx={{ flexGrow: 1 }} />}
                value={product.discardDate}
                onChange={(newValue) => newValue && updateDiscardDate(product, newValue)}
              />
            </LocalizationProvider>
          </Box>
        )}

        <Box sx={{
          display: 'flex',
          marginTop: '16px',
        }}>
          <Button
            variant="contained"
            sx={{ flex: 1 }}
            onClick={() => onClose?.()}>
            {intl.formatMessage({ id: 'mobile.button.saveAndClose.title' })}
          </Button>
        </Box>
      </Box>
    </>
  )
}
